import type { FieldNamesMarkedBoolean, FieldValues } from "react-hook-form"

export function getDirtyPayload<T extends FieldValues>(
  data: T,
  dirtyFields: Partial<FieldNamesMarkedBoolean<T>>,
  idKey?: keyof T,
): T {
  const seed = idKey !== undefined ? ({ [idKey]: data[idKey] } as T) : ({} as T)
  return (Object.keys(dirtyFields) as (keyof T)[]).reduce(
    (acc, key) => ({ ...acc, [key]: data[key] }),
    seed,
  )
}
